import { render, staticRenderFns } from "./BaseFormSpinner.vue?vue&type=template&id=66d2c9e0&scoped=true"
import script from "./BaseFormSpinner.vue?vue&type=script&lang=js"
export * from "./BaseFormSpinner.vue?vue&type=script&lang=js"
import style0 from "./BaseFormSpinner.vue?vue&type=style&index=0&id=66d2c9e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d2c9e0",
  null
  
)

export default component.exports